import { createClient } from "@supabase/supabase-js"

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase env vars are missing.")
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
